import { SavePersonInfoFailure } from './SavePersonInfoFailure';
export default SavePersonInfoFailure;
